<template>
  <section class="sidebar vb" v-bar>
    <div class="sidebar-wrapper">
      <div class="sidebar-content">
        <div class="sidebar-header">
          <img src="static/assets/images/mfs-logo.png" alt="Recruitment" width="120px">
        </div>
        <div class="user-details">
          <div class="user-image">
            <img :src="$store.state.user.userDetails.profilePhotoUrl" alt="user">
            <!-- <a href="#" class="user-link"><i class="mdi mdi-bell-outline"></i></a> -->
          </div>
         <div class="user-name">{{$store.state.user.userDetails.fullName}} <br/> <strong> [{{$store.state.candidateProfile.profileUser}}]</strong></div>
        </div>
       <!--  <language></language> -->
        <p></p>
        <div class="menu-items">
          <!-- <b-link class="menu-item" to="dashboard"><i class="mdi mdi-airplay"></i>Dashboard</b-link> -->
          <b-link class="menu-item" to="agreement" ><i class="mdi mdi-format-list-bulleted"></i>{{$t('sideBar.lblRegistration')}}</b-link>
          <b-link class="menu-item" @click="logout" ><i class="mdi  mdi-logout"></i>{{$t('sideBar.lblLogout')}} </b-link>
          <b-link class="menu-item" to="termsConditions"><i class="mdi mdi-file"></i>{{$t('sideBar.lblTermCondition')}}</b-link>
        </div>
        <div class="sidebar-footer">
          <img src="static/assets/images/logo_mkcl.png" alt="MKCL">
          <div class="copyright">&copy;{{$t('sideBar.lblCopyRights')}} </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios'
import Language from './language.vue'
export default {
  name: 'Sidebar',
  components: {Language},
  data () {
    return {
      selected: '',
      instructions: {},
      docImagePath: 'static/assets/images/dummy.png'
    }
  },
  mounted () {
    this.getUserDetails()
  },
  methods: {
    getUserDetails () {
      axios.get('/r/entry/getUserDetails/' + this.$store.state.candidateProfile.profileUser).then(response => {
        if (response.data !== null) {
          this.$store.commit('STORE_PROFILE_USER_DETAILS', response.data)
          if (response.data.profilePhotoUrl === '') {
            this.$store.commit('STORE_PROFILE_USER_PHOTO', this.docImagePath)
          }
          if (this.$store.state.user.userDetails !== undefined) {
            if (this.$store.state.user.userDetails.profileUrl !== '') {
              this.docImagePath = this.$store.state.user.userDetails.profilePhotoUrl
            }
              // this.username = this.$store.state.user.userDetails.fullName
          }
          /* this.$store.commit('STORE_PROFILE_USER_DETAILS', response.data)
          if (this.$store.state.user.userDetails.personalDetails !== undefined) {
            for (let docImage = 0; docImage < this.$store.state.user.userDetails.documents.length; docImage++) {
              if (this.$store.state.user.userDetails.documents[docImage].docId === this.$store.state.candidateProfile.profileUser + '_ProfilePicture') {
                this.docImagePath = this.$store.state.user.userDetails.documents[docImage].docImage
                break
              } else {
                this.docImagePath = 'static/assets/images/dummy.png'
              }
            } */
        }
      }).catch(function (e) {
        console.error(e)
      })
    },
    logout () {
      var self = this
      window.MKCLAPI.logout().then(function (response) {
        self.$toasted.success(self.$t('sideBar.tostrLogout'))
        window.location.href = self.MFS_REGISTRATION_URL
      }).catch(function (e) {
        console.error(e)
      })
    }
  }
}
</script>

<style lang="scss">
@import '../../../static/assets/styles/scss/variables.scss';

.sidebar {position: fixed !important; top: 0; left: 0; width: 280px; height: 100vh; background: #fff; box-shadow: 0 8px 20px 7px rgba(0, 0, 0, 0.05);
  .sidebar-content {height: 100%; display: flex; flex-direction: column;}
  .sidebar-header {padding: 30px 0; text-align: center;}
  .user-details {position: relative; margin-bottom: 10px; text-align: center;
    .user-image {position: relative; margin: 0 auto 12px; width: 80px;
      img {width: 90px; height: 90px; border-radius: 50px;}
    }
    .user-link {position: absolute; bottom: -2px; right: -2px; background: #fff; width: 30px; height: 30px; border-radius: 50px; font-size: 18px; line-height: 30px; text-align: center; color: $linkcolor; box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);}
    .user-name {font-size: 15px; line-height: 24px; font-weight: 500; color: $linkcolor;}
  }
  .menu-items {margin-bottom: 50px;
    .menu-item {position: relative; display: flex; flex-direction: row; align-items: center; padding: 14px 30px; color: $fontcolor-light; font-size: 14px; line-height: 24px; font-weight: 500;/* text-transform: uppercase;*/ transition: all 0.2s ease-out;
      i {font-size: 21px; line-height: 24px; margin-right: 14px;}
      &:hover, &:focus {text-decoration: none; outline: 0;}
      &.active {color: $fontcolor; box-shadow: inset 8px 0 0 -4px #fe763a;}
    }
  }

  .sidebar-footer {margin-top: auto; padding: 15px 30px; text-align: center;
    img {margin-bottom: 10px; width: 90px;}
    .copyright {font-size: 11px; line-height: 16px; color: $fontcolor-light;}
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/sidebar.vue